/**
 * Global classification filter options for mailbox
 * Used to filter messages across all navigation items
 */
export enum MailClassificationFilter {
  /** Show all messages regardless of classification */
  All = 0,
  /** Show only Zayavlenie (Application) messages */
  Zayavlenie = 1,
  /** Show only Other messages */
  Other = 2
}

